module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mhsmDM/tc-custom/9783956766800_IMGJPG_FrontCover_0.jpg?1703128385055",
      "alt": "This image is the cover for the book The Biglow Papers, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Biglow Papers, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("James Russell Lowell; (February 22, 1819 – August 12, 1891) was an American Romantic poet, critic, editor, and diplomat. He is associated with the Fireside Poets, a group of New England writers who were among the first American poets who rivalled the popularity of British poets. These poets usually used conventional forms and meters in their poetry, making them suitable for families entertaining at their fireside. “The Biglow Papers” can be considered as satirical poetry in Yankee dialect. Lowell opposed the Mexican-American War, regarding it as an attempt to extend slavery. (Excerpt from Wikipedia)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Russell Lowell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Russell Lowell (February 22, 1819 – August 12, 1891) was an American Romantic poet, critic, editor, and diplomat. He is associated with the Fireside Poets, a group of New England writers who were among the first American poets that rivaled the popularity of British poets. These writers usually used conventional forms and meters in their poetry, making them suitable for families entertaining at their fireside. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB-ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0